// <cl-accordion> — .zf-i items, one open at a time (FAQ, product pages).
// Markup: <cl-accordion><div class="zf-i"><button class="zf-q" aria-expanded aria-controls>…</button>
//         <div class="zf-a" id role="region"><div>…</div></div></div></cl-accordion>
// Add [data-multi] to allow several open items.
class ClAccordion extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const q = e.target.closest('.zf-q');
      if (!q || !this.contains(q)) return;
      const item = q.closest('.zf-i');
      const open = !item.classList.contains('on');
      if (open && !this.hasAttribute('data-multi')) {
        this.querySelectorAll('.zf-i.on').forEach((i) => i !== item && this.set(i, false));
      }
      this.set(item, open);
    });
  }
  set(item, open) {
    item.classList.toggle('on', open);
    item.querySelector('.zf-q')?.setAttribute('aria-expanded', String(open));
  }
}
if (!customElements.get('cl-accordion')) customElements.define('cl-accordion', ClAccordion);
